var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChairBlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 255.2 438.99",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "84d56411-8770-41d0-8288-0dbafbf6ca85"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "162.7 53.1 162.7 53.1 164.7 23 164.7 23 162.7 53.1",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome",
    "data-name": "Sfumatura senza nome",
    x1: 731.16,
    y1: 1625.73,
    x2: 734.56,
    y2: 1625.73,
    gradientTransform: "matrix(7.29, 0, 0, -7.29, -5182.48, 11889.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585b5b"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "13c82347-e649-4aa6-95ae-99db47207c40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.1,53.2c-3.8,0-7.6-.1-11.3-.1l1.9-30.2,11.3.8-1.9,29.5",
    style: {
      fill: "none"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_2",
    "data-name": "Sfumatura senza nome 2",
    x1: 731.16,
    y1: 1625.72,
    x2: 734.56,
    y2: 1625.72,
    gradientTransform: "matrix(7.29, 0, 0, -7.29, -5182.48, 11889.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "35d7c3b4-e3d8-4b56-a675-50442ac335fa"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "129.1 52.3 129.1 52.3 130.6 20.8 129.1 52.3",
    style: {
      fill: "none"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 707.42,
    y1: 1626.61,
    x2: 710.82,
    y2: 1626.61,
    gradientTransform: "matrix(6.33, 0, 0, -6.33, -4363.75, 10332.96)",
    xlinkHref: "#Sfumatura_senza_nome"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6278d88b-9446-4d8b-ab1e-6f60bc801008"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.4,52.7c-3.9-.1-7.6-.3-11.3-.4l1.5-31.5,11.3.5-1.5,31.4",
    style: {
      fill: "none"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    "data-name": "Sfumatura senza nome 4",
    x1: 707.42,
    y1: 1626.57,
    x2: 710.82,
    y2: 1626.57,
    gradientTransform: "matrix(6.33, 0, 0, -6.33, -4363.75, 10332.96)",
    xlinkHref: "#Sfumatura_senza_nome_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "70dde540-914f-4080-a3e1-7088938995cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.7,50.6c-4.3-.4-8.1-.9-11.3-1.5l.1-30.2,11.3-.4-.1,32.1",
    style: {
      fill: "none"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    "data-name": "Sfumatura senza nome 5",
    x1: 582.96,
    y1: 1629.84,
    x2: 586.36,
    y2: 1629.84,
    gradientTransform: "matrix(3.61, 0, 0, -3.61, -2016.92, 5918.28)",
    xlinkHref: "#Sfumatura_senza_nome_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da9b2498-ff3f-4b5f-ac76-8154b98a1b44"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "207.9 53.1 210 26.3 207.9 53.1 207.9 53.1",
    style: {
      fill: "none"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_6",
    "data-name": "Sfumatura senza nome 6",
    x1: 749.31,
    y1: 1624.68,
    x2: 752.71,
    y2: 1624.68,
    gradientTransform: "matrix(8.25, 0, 0, -8.25, -5995.7, 13443.24)",
    xlinkHref: "#Sfumatura_senza_nome"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1b3fe72f-c728-4415-b0b8-8884caf7a27e"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "196.5 53.2 198.7 25.2 210 26.3 207.9 53.2 196.5 53.2",
    style: {
      fill: "none"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_7",
    "data-name": "Sfumatura senza nome 7",
    x1: 749.31,
    y1: 1624.73,
    x2: 752.71,
    y2: 1624.73,
    gradientTransform: "matrix(8.25, 0, 0, -8.25, -5995.7, 13443.24)",
    xlinkHref: "#Sfumatura_senza_nome_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb0f5582-6c7f-46ba-84e6-2124491ef9fa"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "244.1 52.5 247 29.6 244.1 52.5 244.1 52.5",
    style: {
      fill: "none"
    }
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_8",
    "data-name": "Sfumatura senza nome 8",
    x1: 779.65,
    y1: 1624,
    x2: 783.05,
    y2: 1624,
    gradientTransform: "matrix(10.93, 0, 0, -10.93, -8305.37, 17791.39)",
    xlinkHref: "#Sfumatura_senza_nome"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d80a6ebf-c022-4996-8d78-ba516d6908aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.7,52.8l3.1-25.1L247,29.6l-2.9,22.9h-1.7c-2.6.1-6,.2-9.7.3",
    style: {
      fill: "none"
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_9",
    "data-name": "Sfumatura senza nome 9",
    x1: 779.65,
    y1: 1624.07,
    x2: 783.05,
    y2: 1624.07,
    gradientTransform: "matrix(10.93, 0, 0, -10.93, -8305.37, 17791.39)",
    xlinkHref: "#Sfumatura_senza_nome_2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "chair_black",
    "data-name": "chair black"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12.84 279.45 9.21 438.99 18.69 438.99 30.55 279.43 12.84 279.45",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.55 279.43 32.32 255.6 13.36 256.8 12.84 279.45 30.55 279.43",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.08 279.45 83.45 438.99 92.93 438.99 104.79 279.45 87.08 279.45",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.79 279.45 106.56 255.6 87.6 256.8 87.08 279.45 104.79 279.45",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.6 279.43 201.83 255.6 220.79 256.8 221.31 279.45 203.6 279.43",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.31 279.45 224.94 438.99 215.46 438.99 203.6 279.43 221.31 279.45",
    style: {
      fill: "#515453"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.86 279.43 135.09 255.6 154.05 256.8 154.57 279.43 136.86 279.43",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.57 279.43 158.2 438.99 148.72 438.99 136.86 279.43 154.57 279.43",
    style: {
      fill: "#515453"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5084",
    d: "M162.4,234.3l-11.3-.8L164.6,22.9l11.3.8L162.4,234.3",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5086",
    d: "M131.7,232l-11.3-.5L130.7,20.7l11.3.5L131.7,232",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5088",
    d: "M103.9,229.4l-11.3.4L93.6,19l11.3-.4-1,210.8",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5090",
    d: "M181.9,235.5l11.3,1.1L210,26.3l-11.3-1.1L181.9,235.5",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5092",
    d: "M209.8,236.7l11.2,1.9L247,29.5l-11.2-1.9-26,209.1",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5094"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#84d56411-8770-41d0-8288-0dbafbf6ca85)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5108",
    d: "M162.7,53.1h0l1.9-30.2h0l-1.9,30.2",
    style: {
      fill: "url(#Sfumatura_senza_nome)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5110"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#13c82347-e649-4aa6-95ae-99db47207c40)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5124",
    d: "M174.1,53.2c-3.8,0-7.6-.1-11.3-.1l1.9-30.2,11.3.8-1.9,29.5",
    style: {
      fill: "url(#Sfumatura_senza_nome_2)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5126"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#35d7c3b4-e3d8-4b56-a675-50442ac335fa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5140",
    d: "M129.1,52.3h0l1.5-31.5-1.5,31.5",
    style: {
      fill: "url(#Sfumatura_senza_nome_3)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5142"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#6278d88b-9446-4d8b-ab1e-6f60bc801008)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5156",
    d: "M140.4,52.7c-3.9-.1-7.6-.3-11.3-.4l1.5-31.5,11.3.5-1.5,31.4",
    style: {
      fill: "url(#Sfumatura_senza_nome_4)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5158"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#70dde540-914f-4080-a3e1-7088938995cd)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5172",
    d: "M104.7,50.6c-4.3-.4-8.1-.9-11.3-1.5l.1-30.2,11.3-.4-.1,32.1",
    style: {
      fill: "url(#Sfumatura_senza_nome_5)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5174"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#da9b2498-ff3f-4b5f-ac76-8154b98a1b44)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5188",
    d: "M207.9,53.1,210,26.2l-2.1,26.9h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_6)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5190"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#1b3fe72f-c728-4415-b0b8-8884caf7a27e)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5204",
    d: "M196.5,53.2l2.2-28L210,26.3l-2.1,26.9H196.5",
    style: {
      fill: "url(#Sfumatura_senza_nome_7)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5206"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bb0f5582-6c7f-46ba-84e6-2124491ef9fa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5220",
    d: "M244.1,52.5,247,29.6l-2.9,22.9h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_8)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5222"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d80a6ebf-c022-4996-8d78-ba516d6908aa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5236",
    d: "M232.7,52.8l3.1-25.1L247,29.6l-2.9,22.9h-1.7c-2.6.1-6,.2-9.7.3",
    style: {
      fill: "url(#Sfumatura_senza_nome_9)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path5238",
    d: "M91.1,0S195.7,5.6,249.2,0l6,2.5-6.4,34.6S110,40.5,91,32.5L91.1,0",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5240",
    d: "M249.2,0l6,2.5-6.4,34.6s-2.9.1-7.9.2L249.2,0",
    style: {
      fill: "#515453"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5386",
    d: "M224.7,258H4.2A4.21,4.21,0,0,1,0,253.9V231.4a4.14,4.14,0,0,1,4.18-4.1H224.8a4.21,4.21,0,0,1,4.2,4.1v22.5a4.37,4.37,0,0,1-4.3,4.1",
    style: {
      fill: "#515453"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5388",
    d: "M166.9,253.8V231.3a4.14,4.14,0,0,0-4.18-4.1H4.2A4.21,4.21,0,0,0,0,231.3v22.5a4.14,4.14,0,0,0,4.18,4.1H162.7a4.09,4.09,0,0,0,4.2-4v-.14",
    style: {
      fill: "#2f2f2f"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChairBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chair-black.d00106913fa95df870f919f725f062ca.svg";